// 图表基本混合
const radarMixin = {
  methods: {
    // 初始化折线图点击事件
    initClickEvent() {
      // 图表区域点击事件
      this.chartInstance.on('click', (params) => {
        switch (params.componentType) {
          // 线条上圆点点击
          case 'series':
            console.log('圆点点击：', params);

            break;
          // 标注点击
          case 'graphic':
            console.log('标注点击：', params);

            break;
        }
      });
      // 图例点击事件
      this.chartInstance.on('legendselectchanged', (params) => {
        // this.legendClick(params);
        console.log('图例点击', params);
      });
    },
    // pointClick(params, pointData, currLineInfo) {
    //   console.log('圆点默认参数--', params);
    //   console.log('pointData--', pointData);
    //   console.log('x轴--', currLineInfo);
    //   this.$emit('pointClick', params, pointData, currLineInfo);
    // },
    // markerClick(params, pointData, currLineInfo) {
    //   console.log('标注默认参数--', params);
    //   console.log('pointData--', pointData);
    //   console.log('x轴--', currLineInfo);
    //   this.$emit('markerClick', params, pointData, currLineInfo);
    // },
  },
};

export { radarMixin };
